let translationsAKEDV = {
	title: 'Kedvencek',
	subTitleNotLoggedIn: 'Mentsd el ezeket az ingatlanokat véglegesen kedvencek listádba, hogy bármely' +
	' eszközről elérhetőek legyenek számodra. A végleges mestéshez jelentkezz be saját fiókodba, vagy regisztrálj és hozz létre egyet.',
	login: 'Bejelentkezés',
	registration: 'Regisztráció',
	emptyList: 'Az Ön kedvenc listája <strong> üres.</strong>',
	emptyListSubTitle: 'Indítson új keresést, és a szivecskére kattintással könnyedén adjon hozzá ingatlanokat kedvencek listájához.',
	listCount: 'Az Ön kedvenc listájában <strong> {{count}} ingatlan</strong> található.',
	and: 'és',
	andAHalf: 'és fél',
	half: 'fél',
	room: 'szoba',
	rooms: 'szoba',
	addComment: 'Megjegyzés hozzáfűzése',
	addedComment: 'Hozzáadott megjegyzés',
	addingDate: 'Hozzáadva',
	comment: 'Megjegyzés',
	saveComment: 'Megjegyzés mentése',
	backToFavs: 'Vissza a kedvencek listához',
	soldNotification: 'Ez az ingatlan már elkelt!',
	inactiveNotification: 'Ezt a hirdetést inaktiválták!',
	becameCheaper: 'olcsóbb lett',
	becameMoreExpensive: 'drágább lett',
	hasOffer: 'ajánlat érkezett rá',
	sold: 'elkelt',
	inactive: 'inaktív',
	saveCount: 'mentések száma',
	deleteComment: 'Megjegyzés törlése',
	deleteCommentQuestion: 'Biztosan törölni akarja a megjegyzést?',
	deleteFavourite: 'Kedvenc törlése',
	deleteFavouriteQuestion: 'Biztos hogy törölni szeretné az ingatlant a kedvencei közül?',
	successDelete: 'Sikeres törlés',
	deleteAll: 'Összes törlése',
	deleteAllQuestion: 'Biztosan ki akarod törölni az összes igatlant a kedvenceid közül?',
	soldEstates: 'Elkelt és inaktivált ingatlanok',
	deleteAllButtonText: 'Összes ingatlan törlése a listából',
	newSearchButtonText: 'Új keresés',
	compareButtonText: 'Ingatlanok összehasonlítása'
};

export default translationsAKEDV;
